import { ApiResponseType } from "../../../core/data/rtk/apiResponseType";
import { baseApi } from "../../../core/data/rtk/baseQuery";
import { PaymentShareDetailsResponse } from "../types/paymentShareDetailsResponse";

interface Data {
    items?: (PaymentShareDetailsResponse)[] | null;
    pageSize: number;
    currentPage: number;
    totalItems: number;
    totalPages: number;
}

export interface PaySharePaymentPayload {
  fee_type: string;
  center_id: number;
  session_id: number;
  course_id: number;
  amount: number;
  students: number[];
}

export const feeShareRazorpayApi = baseApi.injectEndpoints({
    endpoints: (builder) => ({
        makeRazorpaySharePayment: builder.mutation<any, PaySharePaymentPayload>({
            query: (body) => ({
                url: '/center-payments/initiate',
                method: 'POST',
                body,
            }),
            invalidatesTags: ['Shares', 'Students']
        }),
        verifyRazorpaySharePayment: builder.mutation<any, { paymentId: string; payload: any }>({
            query: ({ paymentId, payload }) => ({
                url: `/center-payments/verify/${paymentId}`,
                method: 'POST',
                body: payload,
            }), 
            invalidatesTags: ['Shares', 'Students']
        }),
        getCenterSharePaymentById: builder.query<
            ApiResponseType<{ payments: PaymentShareDetailsResponse }>,
            { id: string }
        >({
            query: ({ id }) => `center-payments/get-by-centerid/${id}`,
            providesTags: ["Shares"],
        }),
        getAllSharePayments: builder.query<
            ApiResponseType<Data>,
            { size?: number; page?: number; search?: string }
        >({
            query: (params) => {
                const queryParams = new URLSearchParams();
                if (params?.size) queryParams.append("size", params.size.toString());
                if (params?.search) queryParams.append("search", params.search);
                if (params?.page) queryParams.append("page", params.page.toString());

                return `center-payments/get-all?${queryParams.toString()}`;
            },
            providesTags: ["Shares"],
        }),
    }),
});

export const { useMakeRazorpaySharePaymentMutation, useVerifyRazorpaySharePaymentMutation, useGetCenterSharePaymentByIdQuery, useGetAllSharePaymentsQuery } = feeShareRazorpayApi;